export default __webpack_public_path__ + "static/media/Kwikdash_banner.adcabcf5.png";